import { gql } from 'apollo-angular';

export const GET_LOCATIONS_QUERY = gql`
  query locations {
    getLocations(filter: {}) {
      id
      name
    }
  }
`;

export interface GetLocationsResponse {
  getLocations: { id: string; name: string }[];
  loading: boolean;
}
